import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=97637b7c"
import script from "./Leaderboard.ts?vue&type=script&lang=js&external"
export * from "./Leaderboard.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports